// application side effects are operations/behavious that occurs after the app has been rendered
import { useIdentifyUserForLaunchDarkly } from '@/hooks/flags/useIdentifyUserForLaunchDarkly';
import { useWaitingRoomSseNotifications } from '@/hooks/useWaitingRoomNotifications/useWaitingRoomSseNotifications';
import { CreatePrescriptionTutorialModal } from './Patient/components/CreatePrescriptionTutorialModal/CreatePrescriptionTutorialModal';
import { useShowInventoryInsightsTutorial } from './Patient/hooks/useShowInventoryInsightsTutorial';

export const AppSideEffects = function () {
  const { openTutorialModal, handleWatchLaterAndDismissModal, handleWatchNow } = useShowInventoryInsightsTutorial();
  // hook for identifying user for LaunchDarkly
  useIdentifyUserForLaunchDarkly();
  // hook for listening to SSE events and displaying notifications
  useWaitingRoomSseNotifications();

  return (
    <CreatePrescriptionTutorialModal
      open={openTutorialModal}
      handleClose={handleWatchLaterAndDismissModal}
      handleClickPrimaryButton={handleWatchNow}
      handleClickSecondaryButton={handleWatchLaterAndDismissModal}
    />
  );
};
